import { theme } from '@prophecy/theme';
import { Stack, Text } from '@prophecy/ui-v3';
import React, { useMemo } from 'react';

import { FileFormatLabels, FileFormats } from '../../config';
import { ImportedFiles } from '../components/ImportedFile';
import { useAcceptedFormats } from '../hook';
import { useImportState } from '../useImportState';
import { UploadFile } from './components/UploadFile';
import { StyledStackContainer, StyledWhiteCard } from './styled';
import { getTotalFileCounts } from './utils';

export const UploadFilesStep = () => {
  const {
    formDataWithActions: {
      formContext: { getValues }
    },
    transpilerState: { uploadedFilePaths }
  } = useImportState();

  const source = getValues('source') as FileFormats;

  const fileCount = useMemo(() => getTotalFileCounts(uploadedFilePaths), [uploadedFilePaths]);
  const supportedFormatString = useAcceptedFormats(source as FileFormats);

  return (
    <StyledWhiteCard>
      <Stack height='100%' width='100%' gap={theme.spaces.x40}>
        <Text level='xl' weight={theme.fontWeight.medium} tone={theme.colors.gray900}>
          3. Upload Files to Transpile
        </Text>
        <Text level='sm' tone={theme.colors.gray700}>
          Upload {FileFormatLabels[source]} files ({supportedFormatString} files supported) then choose the ones in next
          step for validation and parsing. Processing time may vary based on the file count.
        </Text>
        <StyledStackContainer grow='1' padding={`${theme.spaces.x20} 0`}>
          {fileCount > 0 || uploadedFilePaths?.length > 0 ? <ImportedFiles fileCount={fileCount} /> : <UploadFile />}
        </StyledStackContainer>
      </Stack>
    </StyledWhiteCard>
  );
};
